import React, { memo, FC } from 'react';
import {
  StyledWrapper,
  StyledStepsProgressBarInnerContainer,
  StyledIndividualStepContainer,
  StyledStepCount,
  StyledStepName,
  StyledDivider,
} from './styles';

type IndividualStepProps = {
  stepNumber: number;
  stepName: string;
  isActive: boolean;
};

type StepsProgressBarProps = {
  data: IndividualStepProps[];
};

const Step: FC<IndividualStepProps> = ({ stepNumber, isActive, stepName }) => {
  return (
    <>
      {stepNumber !== 1 && <StyledDivider isActive={isActive} />}
      <StyledIndividualStepContainer>
        <StyledStepCount isActive={isActive}>{stepNumber}</StyledStepCount>
        <StyledStepName>{stepName}</StyledStepName>
      </StyledIndividualStepContainer>
    </>
  );
};

const StepsProgressBar: FC<StepsProgressBarProps> = ({ data }) => {
  if (!data?.length) return null;
  const currentActiveStep = data.find(step => step.isActive).stepNumber;

  data.forEach(step => {
    const updatedStep = step;
    if (updatedStep.stepNumber < currentActiveStep) {
      updatedStep.isActive = true;
    }
  });

  return (
    <>
      <StyledWrapper>
        <StyledStepsProgressBarInnerContainer>
          {data?.length > 0 &&
            data.map(({ stepNumber, stepName, isActive }) => {
              return <Step key={stepNumber} stepNumber={stepNumber} stepName={stepName} isActive={isActive} />;
            })}
        </StyledStepsProgressBarInnerContainer>
      </StyledWrapper>
    </>
  );
};

export default memo(StepsProgressBar);
